import { useEffect } from 'react';
import { AppModal } from '@/components/compose/app.modal';
import { CallStateEnum } from '@matap/shared';
import { useSocket } from '@/hooks/use.socket';
import { useAppDispatch } from '@/hooks/use.redux';
import { CallWaitingScreen } from '@/components/compose/call/call.waiting.view';
import { CallTransmittingView } from '@/components/compose/call/call.transmitting.view';
import { AppIconButton } from '@/components/base/app.icon.button';
import styled from 'styled-components/native';
import { actionShowAlert, actionSetPIP } from '@/redux';
import { useCallConnection } from '@/hooks/use.call.connection';
import { useNavigation } from '@react-navigation/native';
import { hpVal } from '../../utils';

export default function CallModal() {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const { activeCall } = useCallConnection();
  const socket = useSocket();

  useEffect(() => {
    if (!activeCall) {
      navigation.goBack();
      return;
    }
    if (activeCall.getState() === CallStateEnum.initiating) {
      activeCall.getDeviceManager().startRing(activeCall.isInitiator);
    } else {
      activeCall.getDeviceManager().stopRing();
    }
  }, [activeCall, navigation]);

  useEffect(() => {
    if (!activeCall) {
      return;
    }
    return () => {
      dispatch(actionSetPIP(true));
    };
  }, [activeCall, dispatch]);

  if (!activeCall) return null;

  if (!socket.isConnected && activeCall.getState() !== CallStateEnum.transmitting) {
    activeCall.destroy();
    dispatch(actionShowAlert('ارتباط شما با سرور قطع می باشد'));
    navigation.goBack();
    return null;
  }

  return (
    <AppModal backButton={false} roundCorners={false}>
      {activeCall.getState() === CallStateEnum.initiating && <CallWaitingScreen connection={activeCall} incoming={!activeCall.isInitiator} />}
      {activeCall.getState() === CallStateEnum.transmitting && <CallTransmittingView connection={activeCall} />}
      <BackButton
        icon={'back'}
        shadow
        color={'white'}
        onPress={() => {
          navigation.goBack();
        }}
      />
    </AppModal>
  );
}

const BackButton = styled(AppIconButton)`
  position: absolute;
  top: ${hpVal(3)};
  left: ${hpVal(3)};
  padding: 10px;
`;
